import { Select } from '@dreamtree-org/twreact-ui';

/**
 * Quantity picker for items sold by quantity (D60): 1..max, max ≤ 10.
 * Composed from the twreact-ui Select (there is no number stepper at this version).
 */
export default function QtySelect({ value, max, onChange, disabled, label = 'Quantity', size = 'md' }) {
  const top = Math.max(1, Math.min(10, Number(max) || 1));
  const options = Array.from({ length: top }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
  return (
    <Select
      label={label}
      size={size}
      options={options}
      value={Math.min(Math.max(1, Number(value) || 1), top)}
      onChange={(v) => onChange(Number(v))}
      disabled={disabled}
      closeOnSelect
    />
  );
}
